import "./tophead.css";
import React, { useRef, useState } from "react";
import { useEffect } from "react";

import { Link } from "react-router-dom";
import { Home, Search } from "@mui/icons-material";
import PersonSearchSharpIcon from "@mui/icons-material/PersonSearchSharp";
import SchoolSharpIcon from "@mui/icons-material/SchoolSharp";
import ChatSharpIcon from "@mui/icons-material/ChatSharp";
import VideoChatSharpIcon from "@mui/icons-material/VideoChatSharp";
import MenuBookSharpIcon from "@mui/icons-material/MenuBookSharp";
import RecordVoiceOverSharpIcon from "@mui/icons-material/RecordVoiceOverSharp";
import OnlinePredictionSharpIcon from "@mui/icons-material/OnlinePredictionSharp";
import KeyboardDoubleArrowRightSharpIcon from '@mui/icons-material/KeyboardDoubleArrowRightSharp';
import LoginIcon from "@mui/icons-material/Login";
import HowToRegSharpIcon from "@mui/icons-material/HowToRegSharp";
import ContactsIcon from "@mui/icons-material/Contacts";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Card, CardContent, Typography, Avatar, Box } from "@mui/material";

const testimonials = [
  {
    images: [
      "assetsfront/images/h0.jpg",
      "assetsfront/images/h1.jpg",
      "assetsfront/images/tlogo2.jpg",
    ],
  },
  {
    images: [
      "assetsfront/images/h0.jpg",
      "assetsfront/images/h1.jpg",
      "assetsfront/images/tlogo2.jpg",
    ],
  },
];

const Banner = () => {
  // Marquee functionality
  // Marquee functionality

  const marqueeRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseOver = () => {
    setIsHovered(true);
    if (marqueeRef.current) {
      marqueeRef.current.stop(); // Stop the marquee when hovered
    }
  };

  const handleMouseOut = () => {
    setIsHovered(false);
    if (marqueeRef.current) {
      marqueeRef.current.start(); // Restart the marquee when mouse leaves
    }
  };

  const settings = {
    dots: true, // Show navigation dots
    infinite: true, // Infinite scrolling
    speed: 700, // Transition speed
    slidesToShow: 1, // Show one slide at a time
    slidesToScroll: 1, // Scroll one slide at a time
    autoplay: true, // Auto-play testimonials
    autoplaySpeed: 3000, // Change testimonial every 3 seconds
  };

  return (
    <div className="rs-banner-section" style={{ top: "10px" }}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-2 p-2">
            <div className="sidebar-area" style={{ fontWeight: "600" }}>
              <div className="cate-box">
                <ul>
                  <li>
                    <Link to={`/`}>
                      <Home style={{ fontSize: 23, color: "#e53935" }} /> Home
                    </Link>
                  </li>
                  <li>
                    <Link to={`/topfaculty-about-us`}>
                      <ContactsIcon
                        style={{ fontSize: 23, color: "#e53935" }}
                      />{" "}
                      About-Us
                    </Link>
                  </li>

                  <li>
                    <Link to={`myteacherlist`}>
                      <PersonSearchSharpIcon
                        style={{ fontSize: 23, color: "#e53935" }}
                      />{" "}
                      Search Teacher
                    </Link>
                  </li>
                  <li>
                    <Link to={`studentlogin`}>
                      <LoginIcon style={{ fontSize: 23, color: "#e53935" }} />{" "}
                      Student Login
                    </Link>
                  </li>
                  <li>
                    <Link to={`studentregister`}>
                      <HowToRegSharpIcon
                        style={{ fontSize: 23, color: "#e53935" }}
                      />{" "}
                      Student Registration
                    </Link>
                  </li>

                  <li>
                    <Link
                      target="_blank"
                      to={`https://topfaculty.co.in/c_pannel/`}
                    >
                      <LoginIcon style={{ fontSize: 23, color: "#e53935" }} />{" "}
                      Teacher Login
                    </Link>
                  </li>
                  <li>
                    <Link to={`facultyregister`}>
                      <HowToRegSharpIcon
                        style={{ fontSize: 23, color: "#e53935" }}
                      />{" "}
                      Teacher Registration
                    </Link>
                  </li>

                  {/* <li>
                    <a href="#">
                      <ChatSharpIcon
                        style={{ fontSize: 23, color: "#e53935" }}
                      />{" "}
                      Student Chat
                    </a>
                  </li> */}
                  <li>
                    <Link to={`/all-Videos`}>
                      {" "}
                      <VideoChatSharpIcon
                        style={{ fontSize: 23, color: "#e53935" }}
                      />{" "}
                      Videos
                    </Link>
                  </li>

                  <li>
                    <Link to={`/our-package-plans`}>
                      <MenuBookSharpIcon
                        style={{ fontSize: 23, color: "#e53935" }}
                      />{" "}
                      Our-Package
                    </Link>
                  </li>
                  {/* <li>
                    <a href="#">
                      <RecordVoiceOverSharpIcon
                        style={{ fontSize: 23, color: "#e53935" }}
                      />{" "}
                      Record Video
                    </a>
                  </li> */}
                  {/* <li>
                    <a href="#">
                      <OnlinePredictionSharpIcon
                        style={{ fontSize: 23, color: "#e53935" }}
                      />{" "}
                      Online Live Class
                    </a>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>

          <div className="col-md-7 p-0" >
            {/* <img src="assetsfront/images/h1.jpg" alt="" /> */}
            <Slider {...settings} >
              {testimonials
                .reduce((uniqueImages, testimonial) => {
                  testimonial.images.forEach((image) => {
                    if (!uniqueImages.includes(image)) {
                      uniqueImages.push(image);
                    }
                  });
                  return uniqueImages;
                }, [])
                .map((image, index) => (
                  <img
                    key={index}
                    src={image}
                    alt="Banner Image"
                    style={{
                      width: "100%",
                      height: "auto",
                      objectFit: "cover",
                    }}
                  />
                ))}
            </Slider>
          </div>

          <div className="shadowbox col-md-3  ">
            <h2
              className="text-bold text-center mt-3"
              style={{ fontSize: "24px" }}
            >
              <strong>Importants</strong>
            </h2>

            <marquee
              ref={marqueeRef}
              class="marq"
              direction="up"
              scrollamount="7"
              behavior="slide"
              width="100%"
              height="100px"
              onMouseOver={handleMouseOver}
              onMouseOut={handleMouseOut}
            >
              <ul>
                <li>
                  <Link target="_blank"
                      to="https://topfaculty.co.in/c_pannel"><KeyboardDoubleArrowRightSharpIcon/>  Counsellor Login</Link>
                </li>
                <li>
                  <Link target="_blank" to="https://vgigroup.co.in/counseller.php"><KeyboardDoubleArrowRightSharpIcon/>  Counsellor List</Link>
                </li>
                <li>
                  <Link to={`/our-package-plans`}><KeyboardDoubleArrowRightSharpIcon/>   Package-Plans </Link>
                </li>
                <li>
                  <Link to={`/our-batches`}><KeyboardDoubleArrowRightSharpIcon/>   Our-Batches </Link>
                </li>
                <li>
                  <Link target="_blank"
                      to="https://topfaculty.co.in/c_pannel"><KeyboardDoubleArrowRightSharpIcon/>   Coaching Portal</Link>
                </li>
                <li>
                  <Link target="_blank"
                      to="https://topfaculty.co.in/c_pannel"><KeyboardDoubleArrowRightSharpIcon/>   Faculty Video Upload </Link>
                </li>
                <li>
                  <Link target="_blank"
                      to="http://topcolleges.co.in/"><KeyboardDoubleArrowRightSharpIcon/>   Best Colleges</Link>
                </li>
                <li>
                  <Link to={`/myteacherlist`}><KeyboardDoubleArrowRightSharpIcon/>  Faculties</Link>
                </li>
                <li>
                  <Link to={`/our-batches`}><KeyboardDoubleArrowRightSharpIcon/>  Secure Payment System </Link>
                </li>
                <li>
                  <Link to={`/contact-us`}><KeyboardDoubleArrowRightSharpIcon/>  24/7 Support </Link>
                </li>
              </ul>
            </marquee>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
